import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionRevisionReimportFaultsFromMeasurementsPathParameters } from 'api/actions/revision-revision-reimport-faults-from-measurements/revision-revision-reimport-faults-from-measurements-path-parameters';
import { RevisionRevisionReimportFaultsFromMeasurementsResponse } from 'api/actions/revision-revision-reimport-faults-from-measurements/revision-revision-reimport-faults-from-measurements-response';

type RevisionRevisionReimportFaultsFromMeasurementsQueryParameters = Record<string, any>;

/**
 * The path of the RevisionRevisionReimportFaultsFromMeasurements action.
 */
export const revisionRevisionReimportFaultsFromMeasurementsActionPath = new SweetPath<
  keyof RevisionRevisionReimportFaultsFromMeasurementsPathParameters
>('/api/revision/revision-reimport-faults-from-measurements/{revisionId}', { path: '{param}' });

/**
 * Creates a contextualized RevisionRevisionReimportFaultsFromMeasurements actions.
 */
export default function createRevisionRevisionReimportFaultsFromMeasurementsAction(axios: AxiosInstance) {
  return function revisionRevisionReimportFaultsFromMeasurementsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionRevisionReimportFaultsFromMeasurementsPathParameters;
    query?: RevisionRevisionReimportFaultsFromMeasurementsQueryParameters;
  }) {
    const path = revisionRevisionReimportFaultsFromMeasurementsActionPath.insert(parameters);

    return axios.request<
      RevisionRevisionReimportFaultsFromMeasurementsResponse,
      RevisionRevisionReimportFaultsFromMeasurementsResponse
    >({
      method: 'post',
      url: path,
      params: query,

      headers,
    });
  };
}
